import React from "react";

function TextItalic(props) {
  return (
    <p className="font-italic fw-bold" style={{color: "#373F68"}}>{props.text}</p>
  );
}

export default TextItalic;